import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { TpModalModule } from 'app/components/tp-modal/tp-modal.module';
import { AiContentGeneratorComponent } from './ai-content-generator.component';

@NgModule({
    declarations: [AiContentGeneratorComponent],
    imports: [
        CommonModule,
        FormsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        TranslateModule,
        TpModalModule,
    ],
    exports: [AiContentGeneratorComponent],
})
export class AiContentGeneratorModule {
}
